<template>
  <div
    class="
      room-card-tag
      tw-text
      tw-w-min
      tw-whitespace-nowrap
      tw-px-2
      tw-text-xs
      tw-rounded-md
      tw-border
      tw-box-border
      tw-flex
      tw-justify-between
      tw-gap-2
    "
    :class="getStyle()"
  >
    <span>{{ tag | tagTitle }}</span>
    <button v-if="removable" class="tw-flex-none" @click="onRemoveTag">
      <svg
        class="tw-w-3 tw-h-3 tw-text-gray-400 tw-fill-current"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      >
        <path
          d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "RoomCardTag",
  props: {
    tag: Object,
    removable: Boolean,
  },
  data() {
    return {
      color: "stone",
    };
  },
  computed: {},
  watch: {
    tag: {
      immediate: true,
      handler: function (tag) {
        let type = tag.Type;
        if (!type) return "stone";
        if (type === "issue") this.color = "red";
        if (type === "customer") this.color = "green";
        if (type === "order") this.color = "blue";
      },
    },
  },
  methods: {
    getStyle() {
      const type = this.tag.Type;
      if (type === "issue") {
        return "tw-text-red-500 tw-bg-red-100 tw-border-red-300";
      }
      if (type === "customer") {
        return "tw-text-green-500 tw-bg-green-100 tw-border-green-300";
      }
      if (type === "order") {
        return "tw-text-blue-500 tw-bg-blue-100 tw-border-blue-300";
      }
    },
    onRemoveTag() {
      console.log("onRemoveTag", this.tag);
      this.$emit("on-remove", this.tag);
    },
  },
  filters: {
    tagTitle(value) {
      if (value.Type === "order") {
        return value.OrderId;
      }
      return value.Title;
    },
  },
};
</script>

<style>

</style>
